import { apiClient } from './apiClient';
import { type BackendPlan } from './userService';

export async function fetchPlans(): Promise<BackendPlan[]> {
    try {
        const response = await apiClient.get<BackendPlan[]>('/api/plans/');
        return response.data ?? [];
    } catch (err) {
        console.warn('[plansService] Failed to fetch plans', err);
        return [];
    }
}
